import { render, staticRenderFns } from "./LevelDetails.vue?vue&type=template&id=c9207314&"
import script from "./LevelDetails.vue?vue&type=script&lang=js&"
export * from "./LevelDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports